import React from 'react';
import { ArrowRight } from 'lucide-react';

const WhoItsFor = () => {
  const audiences = [
    {
      label: 'Charities & Non-Profits',
      sources: ['Charity Governance Code', 'Charities Act 2011 & 2022', 'Charity Commission guidance (CC3, CC8, CC19…)', 'Charity SORP (FRS 102)'],
    },
    {
      label: 'Limited Companies',
      sources: ['Companies Act 2006', 'Wates Corporate Governance Principles', 'FRC Guidance on Board Effectiveness', 'Bribery Act 2010'],
    },
    {
      label: 'Startups',
      sources: ['Companies Act 2006', 'Investor Readiness Framework', 'UK GDPR / Data Protection Act 2018', 'Wates Principles'],
    },
    {
      label: 'PLCs',
      sources: ['UK Corporate Governance Code 2024', 'FCA Listing Rules & DTRs', 'Market Abuse Regulation (MAR)', 'Companies Act 2006'],
    },
  ];

  return (
    <section id="who-its-for" className="py-24 md:py-32 px-6 max-w-7xl mx-auto border-t border-ink/5">
      <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center">
        <div className="lg:col-span-7">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 text-ink leading-tight">
            Built for organisations that take governance{' '}
            <span className="highlighter mt-2 block">seriously.</span>
          </h2>
          <p className="text-lg md:text-xl text-ink/60 mb-6 leading-relaxed font-medium">
            GovernWell is designed for organisations that want stronger governance, better
            oversight, and more effective boards.
          </p>
          <p className="text-lg md:text-xl text-ink/60 leading-relaxed font-medium">
            Whether you're strengthening governance today or preparing for future growth,
            GovernWell provides a clear path forward.
          </p>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="absolute inset-0 bg-lime blur-[80px] opacity-20 rounded-full transform scale-90 translate-y-10"></div>
          <div className="bg-white border border-ink/5 rounded-3xl p-8 md:p-10 shadow-saas relative z-10">
            <p className="text-sm font-bold tracking-[0.15em] uppercase text-ink/50 mb-8 border-b border-ink/5 pb-4">Ideal for</p>
            <p className="sr-only">Every assessment question is mapped to the governance sources relevant to your organisation type.</p>
            <div className="flex flex-col gap-6">
              {audiences.map((item, i) => (
                <div key={i} className="group cursor-default">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-cream border border-ink/5 flex items-center justify-center group-hover:bg-lime group-hover:border-lime transition-colors shrink-0 shadow-sm">
                      <ArrowRight className="w-5 h-5 text-ink/40 group-hover:text-ink transition-colors" />
                    </div>
                    <span className="font-bold text-xl text-ink/80 group-hover:text-ink transition-colors">{item.label}</span>
                  </div>
                  <p className="mt-2 ml-14 text-sm text-ink/50 leading-relaxed font-medium">
                    {item.sources.join(' · ')}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
